// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "service-3xk20";
var _3 = "title-hFrbN";
export { _1 as "__esModule", _2 as "service", _3 as "title" }
export default { "__esModule": _1, "service": _2, "title": _3 }
